import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import Menu from './Menu';

import logo from '../assets/images/logo_sindicato_metalurgicos_bauru_retangular_fundo_transparente.png';

function Header() {
	const selectedPath = window.location.pathname;
	const isSpecificPage = ['/fim-da-escala-6x1'].includes(selectedPath);
	return (
		<>
			{!isSpecificPage && <div className="header-topbar">
				<Container className="d-flex justify-content-between align-items-center">
					<span>Sindicato dos Metalúrgicos de Bauru e Região</span>
					<span>
						<a href="tel:+551432324367">(14) 3232-4367</a>
						<span className="mx-2">|</span>
						<a href="mailto:sindimetalurgicos@uol.com.br">sindimetalurgicos@uol.com.br</a>
					</span>
				</Container>
			</div>}
			<header className="site-header">
				<Container>
					<Navbar expand="lg" className="px-0 py-2">
						{!isSpecificPage && <Navbar.Brand href="/">
							<img
								src={logo}
								alt="Logo do Sindicato dos Metalúrgicos de Bauru e Região"
								className="header-logo"
							/>
						</Navbar.Brand>}
						<Menu />
					</Navbar>
				</Container>
			</header>
		</>
	);
}

export default Header;